import React from 'react';
export type DentalIconProps = {
  className?: string;
  strokeWidth?: number;
};
const TOOTH_PATH = 'M8.5 3.6C6.6 3.6 5 5.1 5 7.3c0 2.1.6 3.3 1 5.3.4 2 .5 5 1.9 5 1.3 0 1.4-3.2 2.6-3.2h1c1.2 0 1.3 3.2 2.6 3.2 1.4 0 1.5-3 1.9-5 .4-2 1-3.2 1-5.3 0-2.2-1.6-3.7-3.5-3.7-1.2 0-2 .6-3 .6s-1.8-.6-3-.6z';
function Svg({
  className = 'h-8 w-8',
  strokeWidth = 1.5,
  children
}: DentalIconProps & {
  children: React.ReactNode;
}) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" className={className} data-id="element-122" data-mp="36n4nmzqg44w1">
      {children}
    </svg>;
}

/** Diente con líneas de dolor irradiando */
export function ToothPainIcon(props: DentalIconProps) {
  return <Svg {...props} data-id="element-123" data-mp="3pjw656y5yfz1">
      <path d={TOOTH_PATH} data-id="element-124" data-mp="3pjmbv7635mnj" />
      <path d="M18.6 4.6c1.1 1.2 1.1 3.4 0 4.6" data-id="element-125" data-mp="3ucp85n28za7f" />
      <path d="M21 2.8c1.9 2.1 1.9 6.1 0 8.2" data-id="element-126" data-mp="3udgsu2ub3nix" />
    </Svg>;
}

/** Diente limpio con destellos */
export function ToothSparkleIcon(props: DentalIconProps) {
  return <Svg {...props} data-id="element-127" data-mp="3hevcyqmrz10v">
      <path d={TOOTH_PATH} data-id="element-128" data-mp="3hfex8dzwe1i2" />
      <path d="M19 2.6l.75 1.75L21.5 5.1l-1.75.75L19 7.6l-.75-1.75L16.5 5.1l1.75-.75z" data-id="element-129" data-mp="3hbzft4ir4gdh" />
      <path d="M21.6 8.4l.3.7.7.3-.7.3-.3.7-.3-.7-.7-.3.7-.3z" data-id="element-130" data-mp="3w4t7rpf7moz1" />
    </Svg>;
}

/** Sonrisa con destellos a los lados */
export function SmileSparkleIcon(props: DentalIconProps) {
  return <Svg {...props} data-id="element-131" data-mp="8w7dypszqet1">
      <path d="M4.4 10.4c2.3-1 4.8-1.5 7.6-1.5s5.3.5 7.6 1.5c-1.6 4-4.4 6.1-7.6 6.1s-6-2.1-7.6-6.1z" data-id="element-132" data-mp="4wfbmuu6x4w4" />
      <path d="M5.4 10.9c2 .9 4.2 1.4 6.6 1.4s4.6-.5 6.6-1.4" data-id="element-133" data-mp="iw6j0cq7bn15" />
      <path d="M3 3.6l.6 1.4L5 5.6l-1.4.6L3 7.6l-.6-1.4L1 5.6l1.4-.6z" data-id="element-134" data-mp="ivoi32slgkmw" />
      <path d="M21 4.4l.5 1.1 1.1.5-1.1.5-.5 1.1-.5-1.1-1.1-.5 1.1-.5z" data-id="element-135" data-mp="dy51vxcc5xsb" />
    </Svg>;
}

/** Diente con bracket de ortodoncia */
export function ToothBracesIcon(props: DentalIconProps) {
  return <Svg {...props} data-id="element-136" data-mp="2fpi6smeb05od">
      <path d={TOOTH_PATH} data-id="element-137" data-mp="2fq1d15uld5mk" />
      <path d="M5.6 11.2h12.8" data-id="element-138" data-mp="2fqt9sjzxd9ef" />
      <rect x="9.4" y="9.3" width="5.2" height="3.8" rx="1.1" data-id="element-139" data-mp="jm3nteqi3a6j" />
    </Svg>;
}

/** Implante dental: corona + tornillo */
export function DentalImplantIcon(props: DentalIconProps) {
  return <Svg {...props} data-id="element-140" data-mp="slibk6fa96nc">
      <path d="M8.4 3.4c-1.7 0-2.9 1.3-2.9 2.9 0 1.5.6 2.4 1.1 3.6h10.8c.5-1.2 1.1-2.1 1.1-3.6 0-1.6-1.2-2.9-2.9-2.9-1.1 0-1.9.6-2.6.6h-2.1c-.6 0-1.4-.6-2.5-.6z" data-id="element-141" data-mp="skys2l9zia77" />
      <path d="M12 9.9v2.2" data-id="element-142" data-mp="12kfxd1lbqm2n" />
      <path d="M9.6 12.6h4.8" data-id="element-143" data-mp="12j4vx8fcpqep" />
      <path d="M10.1 15.1h3.8" data-id="element-144" data-mp="12jxv9obzddmt" />
      <path d="M10.7 17.6h2.6" data-id="element-145" data-mp="17j0zj6k4zftq" />
      <path d="M12 19.9v.8" data-id="element-146" data-mp="17i94bwugbk3z" />
    </Svg>;
}

/** Cruz médica: urgencias */
export function MedicalCrossIcon(props: DentalIconProps) {
  return <Svg {...props} data-id="element-147" data-mp="1ccdaidvw7o40">
      <path d="M9.8 3.5h4.4c.5 0 .9.4.9.9v4.4h4.4c.5 0 .9.4.9.9v4.4c0 .5-.4.9-.9.9h-4.4v4.4c0 .5-.4.9-.9.9H9.8c-.5 0-.9-.4-.9-.9v-4.4H4.5c-.5 0-.9-.4-.9-.9V9.7c0-.5.4-.9.9-.9h4.4V4.4c0-.5.4-.9.9-.9z" data-id="element-148" data-mp="1gbcn8knv8p60" />
    </Svg>;
}

/** Brújula: no sé por dónde empezar */
export function CompassExploreIcon(props: DentalIconProps) {
  return <Svg {...props} data-id="element-149" data-mp="20eqmk2jwz9ly">
      <circle cx="12" cy="12" r="9" data-id="element-150" data-mp="20fa4hj9kdxzz" />
      <path d="M15.2 8.8l-1.9 4.5-4.5 1.9 1.9-4.5z" data-id="element-151" data-mp="1vem78fuqskxb" />
    </Svg>;
}